import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const STORAGE_KEY = "dra_vacation_seen";

export default function VacationOverlay() {
  const [vac, setVac] = useState(null);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    api.get("/settings").then((r) => {
      if (!mounted) return;
      const v = r.data?.vacation;
      if (v?.active) {
        setVac(v);
        setVisible(true);
      } else {
        setVisible(false);
      }
    }).catch(() => {});
    return () => { mounted = false; };
  }, [location.pathname]);

  // Never show on admin routes so the owner can always manage
  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  if (!visible || !vac) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/95 backdrop-blur-md p-4"
      data-testid="vacation-overlay"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative max-w-2xl w-full text-center text-white animate-fade-up">
        <img
          src="/logo.png"
          alt="D.R Automobile"
          className="h-32 md:h-40 w-auto object-contain mx-auto mb-8"
        />
        <div className="inline-flex items-center gap-3 bg-amber-500/15 border border-amber-500/40 text-amber-300 text-[10px] uppercase tracking-[0.3em] px-4 py-2 mb-6">
          <span className="w-1.5 h-1.5 bg-amber-400 rounded-full animate-pulse" />
          Aktuell nicht erreichbar
        </div>

        <h1 className="font-heading font-bold text-4xl md:text-6xl tracking-tight leading-[1.05] mb-6">
          {vac.title || "Wir sind auf Betriebsurlaub"}
        </h1>

        {vac.message && (
          <p className="font-serif italic text-xl md:text-2xl text-slate-200 leading-snug mb-8 max-w-xl mx-auto">
            {vac.message}
          </p>
        )}

        {vac.return_date && (
          <div className="inline-block border-y border-white/20 py-5 px-8 mb-10">
            <div className="text-[10px] uppercase tracking-[0.3em] text-slate-400 mb-2">Wieder für Sie da ab</div>
            <div className="font-heading font-bold text-3xl md:text-4xl text-white">{vac.return_date}</div>
          </div>
        )}

        <div className="flex items-center justify-center gap-6 text-sm text-slate-300 flex-wrap">
          <a href="tel:+436677608726" className="hover:text-amber-400 transition-crisp">+43 667 760 8726</a>
          <span className="text-slate-600">·</span>
          <a href="mailto:kontakt@dr-automobile.at" className="hover:text-amber-400 transition-crisp">kontakt@dr-automobile.at</a>
        </div>

        <p className="text-[11px] text-slate-500 mt-10">D.R Automobile · Ringgasse 6, 4840 Vöcklabruck</p>
      </div>
    </div>
  );
}
